import { CLOActionTypes, CLOState } from 'types';
import { Reducer } from 'redux';

const initialState: CLOState = {
  loadingTopThreeCLO: false,
  topThreeCLO: {},
  loadingCLODetails: false,
  CLODetails: {},
  loadingCLOListing: false,
  CLOListing: {},
  addingCLOEvent: false,
  CLOEvent: {},
  addingCLOAsFavourite: false,
  addCLOAsFavourite: {},
  removingCLOAsFavourite: false,
  removeCLOAsFavourite: {},
  hidingCLO: false,
  unhidingCLO: false,
  refreshCLO: true
};

const reducer: Reducer<CLOState> = (state = initialState, action: any) => {
  switch (action.type) {
    case CLOActionTypes.FETCH_TOP_THREE_CLO_START: {
      return {
        ...state,
        loadingTopThreeCLO: true,
        topThreeCLO: {}
      };
    }
    case CLOActionTypes.FETCH_TOP_THREE_CLO_SUCCESS: {
      return {
        ...state,
        loadingTopThreeCLO: false,
        topThreeCLO: action.payload
      };
    }
    case CLOActionTypes.FETCH_TOP_THREE_CLO_FAILURE: {
      return {
        ...state,
        loadingTopThreeCLO: false,
        topThreeCLO: {}
      };
    }
    case CLOActionTypes.FETCH_CLO_LISTING_START: {
      return {
        ...state,
        loadingCLOListing: true,
        CLOListing: {}
      };
    }
    case CLOActionTypes.FETCH_CLO_LISTING_SUCCESS: {
      return {
        ...state,
        loadingCLOListing: false,
        CLOListing: action.payload
      };
    }
    case CLOActionTypes.FETCH_CLO_LISTING_FAILURE: {
      return {
        ...state,
        loadingCLOListing: false,
        CLOListing: {}
      };
    }
    case CLOActionTypes.FETCH_CLO_DETAILS_START: {
      return {
        ...state,
        loadingCLODetails: true,
        CLODetails: {}
      };
    }
    case CLOActionTypes.FETCH_CLO_DETAILS_SUCCESS: {
      return {
        ...state,
        loadingCLODetails: false,
        CLODetails: action.payload
      };
    }
    case CLOActionTypes.FETCH_CLO_DETAILS_FAILURE: {
      return {
        ...state,
        loadingCLODetails: false,
        CLODetails: {}
      };
    }
    case CLOActionTypes.ADD_CLO_EVENT_START: {
      return {
        ...state,
        addingCLOEvent: true,
        CLOEvent: {}
      };
    }
    case CLOActionTypes.ADD_CLO_EVENT_SUCCESS: {
      return {
        ...state,
        addingCLOEvent: false,
        CLOEvent: action.payload
      };
    }
    case CLOActionTypes.ADD_CLO_EVENT_FAILURE: {
      return {
        ...state,
        addingCLOEvent: false,
        CLOEvent: {}
      };
    }
    case CLOActionTypes.ADD_CLO_AS_FAVOURITE_START: {
      return {
        ...state,
        addingCLOAsFavourite: true,
        addCLOAsFavourite: {}
      };
    }
    case CLOActionTypes.ADD_CLO_AS_FAVOURITE_SUCCESS: {
      return {
        ...state,
        addingCLOAsFavourite: false,
        addCLOAsFavourite: action.payload
      };
    }
    case CLOActionTypes.ADD_CLO_AS_FAVOURITE_FAILURE: {
      return {
        ...state,
        addingCLOAsFavourite: false,
        addCLOAsFavourite: {}
      };
    }
    case CLOActionTypes.REMOVE_CLO_AS_FAVOURITE_START: {
      return {
        ...state,
        removingCLOAsFavourite: true,
        removeCLOAsFavourite: {}
      };
    }
    case CLOActionTypes.REMOVE_CLO_AS_FAVOURITE_SUCCESS: {
      return {
        ...state,
        removingCLOAsFavourite: false,
        removeCLOAsFavourite: action.payload
      };
    }
    case CLOActionTypes.REMOVE_CLO_AS_FAVOURITE_FAILURE: {
      return {
        ...state,
        removingCLOAsFavourite: false,
        removeCLOAsFavourite: {}
      };
    }
    case CLOActionTypes.HIDE_CLO_START: {
      return {
        ...state,
        hidingCLO: true
      };
    }
    case CLOActionTypes.HIDE_CLO_SUCCESS: {
      return {
        ...state,
        hidingCLO: false
      };
    }
    case CLOActionTypes.HIDE_CLO_FAILURE: {
      return {
        ...state,
        hidingCLO: false
      };
    }
    case CLOActionTypes.UNHIDE_CLO_START: {
      return {
        ...state,
        unhidingCLO: true
      };
    }
    case CLOActionTypes.UNHIDE_CLO_SUCCESS: {
      return {
        ...state,
        unhidingCLO: false
      };
    }
    case CLOActionTypes.UNHIDE_CLO_FAILURE: {
      return {
        ...state,
        unhidingCLO: false
      };
    }

    case CLOActionTypes.REFRESH_TOP_THREE_CLO_START: {
      return {
        ...state,
        refreshCLO: false
      };
    }

    default:
      return state;
  }
};

export { reducer as CLOReducer };
